export type NotificationState = 'unseen' | 'seen' | 'archived';

// Channels the frontend renders with bespoke UI — any other channel falls back to GenericNotification
export type KnownNotificationChannel = 'join_request' | 'join_request_rejected';
export type NotificationChannel =
  | KnownNotificationChannel
  | (string & Record<never, never>);

export type NotificationStatus = 'all' | 'unread' | 'read' | 'archived';

export interface JoinRequestPayload {
  username: string;
  email: string;
  user_id: string;
  company_id?: string;
  join_request_id?: string;
}

export interface NotificationItem {
  id: string;
  channel: NotificationChannel;
  header: string;
  // Pre-rendered HTML — always sanitize before rendering, see sanitizeNotificationHtml
  body: string;
  // Channel-specific data, narrowed by the component that knows the channel
  payload: Record<string, unknown>;
  created_at: string;
  read_at: string | null;
  archived_at: string | null;
}

export interface InboxResponse {
  items: NotificationItem[];
  next_cursor: string | null;
}

// A type alias rather than an interface so it stays assignable to the api client's params record
export type InboxQueryParams = {
  status?: NotificationStatus;
  limit?: number;
  cursor?: string;
};

export function getNotificationState(notification: NotificationItem): NotificationState {
  if (notification.archived_at) {
    return 'archived';
  }
  if (notification.read_at) {
    return 'seen';
  }
  return 'unseen';
}
